module.exports = __webpack_public_path__ + "robots.txt";


//////////////////
// WEBPACK FOOTER
// ./src/robots.txt
// module id = ./src/robots.txt
// module chunks = 4